import { render } from "./ModalTransactions.vue?vue&type=template&id=3e3843ee&scoped=true"
import script from "./ModalTransactions.vue?vue&type=script&lang=js"
export * from "./ModalTransactions.vue?vue&type=script&lang=js"

import "./ModalTransactions.vue?vue&type=style&index=0&id=3e3843ee&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3843ee"]])

export default __exports__